import { Plugins } from '@capacitor/core';
import { setContext } from 'apollo-link-context';
import { merge } from 'lodash-es';

import logger from 'utils/logger';

const { Device } = Plugins;

const DEVICE_MODEL_HEADER = 'x-user-device-model';

export const withDeviceModelHeaders = setContext((_, previousContext) =>
  Device.getInfo()
    .then(info => {
      if (info) {
        return merge(
          {
            headers: {
              [DEVICE_MODEL_HEADER]: info.model
            }
          },
          previousContext
        );
      }
      return previousContext;
    })
    .catch(e => logger.error({ e, message: 'Could not set device model header' }))
);
